module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.2f3e9f80.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/icons/linearicons/Linearicons-Free.ttf
// module id = 325
// module chunks = 0